import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_77c7e095-6aee-4db7-89db-d1905485427a/artifacts/rg0086kf_Untitled%20design%20%283%29.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-stone-50 border-t border-stone-200">
      <div className="px-6 md:px-12 lg:px-24 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-6 site-logo">
              <img
                src={LOGO_URL}
                alt="biomstudio"
                className="h-28 md:h-32 w-auto object-contain mix-blend-multiply"
              />
            </Link>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-manrope text-xs uppercase tracking-[0.2em] font-medium text-stone-900 mb-6">
              Navigation
            </h4>
            <nav className="flex flex-col gap-3">
              {[
                { to: '/about', label: 'About' },
                { to: '/services', label: 'Services' },
                { to: '/projects', label: 'Projects' },
                { to: '/contact', label: 'Contact' },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  data-testid={`footer-nav-${link.label.toLowerCase()}`}
                  className="font-dm-sans text-stone-500 hover:text-stone-900 transition-colors duration-300"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="font-manrope text-xs uppercase tracking-[0.2em] font-medium text-stone-900 mb-6">
              Connect
            </h4>
            <div className="space-y-4">
              <a
                href="mailto:mail.biomstudio@gmail.com"
                data-testid="footer-email"
                className="block font-dm-sans text-stone-500 hover:text-stone-900 transition-colors duration-300"
              >
                mail.biomstudio@gmail.com
              </a>
              <a
                href="tel:+917206235078"
                className="block font-dm-sans text-stone-500 hover:text-stone-900 transition-colors duration-300"
              >
                +91-7206235078
              </a>
              <p className="font-dm-sans text-stone-500 text-sm leading-relaxed">
                511, Block D&E<br />
                Chandigarh Citi Centre<br />
                VIP Road, Zirakpur<br />
                Punjab, India
              </p>
              <div className="flex gap-4 pt-2">
                <a
                  href="https://www.instagram.com/biom.studio?igsh=dnB5ZnhxZThtMm5y"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="social-instagram"
                  className="text-stone-400 hover:text-stone-900 transition-colors duration-300"
                  aria-label="Instagram"
                >
                  <Instagram size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-stone-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-dm-sans text-xs text-stone-400">
            © {currentYear} biomstudio. All rights reserved.
          </p>
          <p className="font-dm-sans text-xs text-stone-400">
            Crafted with precision
          </p>
        </div>
      </div>
    </footer>
  );
};
